<template>
  <div class="container">
    <div class="tab">箱区管理</div>
    <div class="content">
      <div class="column">
        <div class="flex">
          <img src="@/assets/images2/icon1.png" class="img" />
          <div class="flex_row">
            <div class="itme1_title" style="color: #2df9cc">站存箱</div>
            <div class="item1_num" style="color: #29f8e9">4968</div>
          </div>
        </div>
        <div class="flex">
          <img src="@/assets/images2/icon2.png" class="img" />
          <div class="flex_row">
            <div class="itme1_title" style="color: #41edff">铁路空箱</div>
            <div class="item1_num" style="color: #4feeff">4968</div>
          </div>
        </div>
        <div class="flex">
          <img src="@/assets/images2/icon4.png" class="img" />
          <div class="flex_row">
            <div class="itme1_title" style="color: #41edff">自备重箱</div>
            <div class="item1_num" style="color: #4feeff">4968</div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="flex">
          <img src="@/assets/images2/icon3.png" class="img" />
          <div class="flex_row">
            <div class="itme1_title" style="color: #cdda48">空箱</div>
            <div class="item1_num" style="color: #efff72">4968</div>
          </div>
        </div>
        <div class="flex">
          <img src="@/assets/images2/icon5.png" class="img" />
          <div class="flex_row">
            <div class="itme1_title" style="color: #34dafa">铁路重箱</div>
            <div class="item1_num" style="color: #34dafa">4968</div>
          </div>
        </div>
        <div class="flex">
          <img src="@/assets/images2/icon6.png" class="img" />
          <div class="flex_row">
            <div class="itme1_title" style="color: #41edff">站存待发箱</div>
            <div class="item1_num" style="color: #4feeff">4968</div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="flex">
          <img src="@/assets/images2/icon7.png" class="img" />
          <div class="flex_row">
            <div class="itme1_title" style="color: #97caff">重箱</div>
            <div class="item1_num" style="color: #a4d1ff">4968</div>
          </div>
        </div>
        <div class="flex">
          <img src="@/assets/images2/icon8.png" class="img" />
          <div class="flex_row">
            <div class="itme1_title" style="color: #2df9cc">自备箱</div>
            <div class="item1_num" style="color: #29f8e9">4968</div>
          </div>
        </div>
        <div class="flex">
          <img src="@/assets/images2/icon9.png" class="img" />
          <div class="flex_row">
            <div class="itme1_title" style="color: #41edff">站存待交付箱</div>
            <div class="item1_num" style="color: #4feeff">4968</div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="flex">
          <img src="@/assets/images2/icon10.png" class="img" />
          <div class="flex_row">
            <div class="itme1_title" style="color: #97caff">铁路箱</div>
            <div class="item1_num" style="color: #a4d1ff">4968</div>
          </div>
        </div>
        <div class="flex">
          <img src="@/assets/images2/icon11.png" class="img" />
          <div class="flex_row">
            <div class="itme1_title" style="color: #2df9cc">自备空箱</div>
            <div class="item1_num" style="color: #29f8e9">4968</div>
          </div>
        </div>
        <div class="flex">
          <img src="@/assets/images2/icon12.png" class="img" />
          <div class="flex_row">
            <div class="itme1_title" style="color: #41edff">场外铁路箱</div>
            <div class="item1_num" style="color: #4feeff">4968</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  components: {
    // ICountUp,
  },
  data() {
    return {
      delay: 2000,
    };
  },
  methods: {},
};
</script>
<style scoped>
.img {
  width: 99px !important;
  height: 90px !important;
}
.itme1_title {
  font-size: 25px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  /* color: #2DF9CC; */
}
.tab {
  width: 100%;
  height: 70px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 3% 3%;
  box-sizing: border-box;
  font-size: 25px;
  color: white;
}

.item1_num {
  font-size: 33px;
  font-family: Source Han Sans CN;
  font-weight: bold;

  padding-top: 10px;
}
.flex {
  display: flex;
  align-items: center;
  justify-content:center;
  margin-bottom: 66px;
}

.flex_row {
  width: 172px;
  height: 108px;
  background: url('../../../../assets/images2/bg5.png') no-repeat;
  background-position-x: -8px;
  margin-left:3% ;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-content: space-around;
  justify-content: center;
  padding-left: 3%;
  box-sizing: border-box;
}

.container {
  width: 100%;
  height: 100%;

  background: url("../../../../assets/images2/bg4.png") no-repeat;
  background-size: 100% 100%;
}
.content {
  width: 100%;
  height:496px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  margin-top: 2%;
}
.column {
  width:330px;
  height: 100%;
  align-content: space-around;
}
.item {
  display: flex;
  align-items: center;
}
.item img {
  /* width: 70px;
  height: 70px; */
  margin-right: 30px;
}
.item .item-content {
  display: flex;
  flex-direction: column;
  font-size: 25px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  line-height: 35px;
}
/* .item-content span{

} */
</style>
